import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import CustomSelect from '../../../../../Components/Common/CustomSelect'
import CustomCollapse from '../../../../../Components/Common/CustomCollapse'
import { expressionOption, includeExclude } from '../../../../../common/feedTypes'
import { ReactComponent as DraggableSvg } from "../../../../../assets/images/svg/draggable.svg";
import { Input, Label } from 'reactstrap';
import { addOperationMatches, setOperationMatches, removeOperationMatches, setOperation } from '../../../../../slices/feeds/reducer';


function FilterIcon() {
  return (
    <div className='avatar-xs flex-shrink-0 me-2'>
      <span className='avatar-title rounded bg-success text-success'>
        <i className='ri-filter-2-line'></i>
      </span>
    </div>
  )
}

function FilterCollapse(
  { idx, name, matches = [], caseSensitive, groupPath, relativePath, onRemove, onDuplicate,
    onPickGroup, onPickField, handleOperationSelectChange = () => { }, changeOperationMatch = () => { },
    handleOperationMatches = () => { }, handleCheck = () => { }, handleNameChange, canEdit }) {
      const [isCollapsed, setIsCollapsed] = useState(true);
  return (
    <CustomCollapse
      key={idx}
      icon={<FilterIcon />}
      name={name}
      className='filter-accordion'
      toggler={"filter-" + idx}
      btn={"btn-soft-success"}
      onRemove={onRemove}
      onDuplicate={onDuplicate}
      canEdit={canEdit}
      isCollapsed={isCollapsed}
      setIsCollapsed={setIsCollapsed}
      onChange={handleNameChange}
    >
      <div className='w-100 d-flex flex-wrap align-items-center gap-2'>
        <CustomSelect
          className='btn btn-primary dropdown-toggle fw-bold'
          tag="button"
          options={includeExclude}
          onChange={(item) => handleOperationSelectChange("type", item.value)}
          value={includeExclude[0].name}
          disabled={!canEdit}
        />
        with
        <button className='btn btn-primary dropdown-toggle mx-1 fw-bold' type='button' onClick={onPickField} disabled={!canEdit}>
          {relativePath !== "" ? relativePath : "Pick a field"}
        </button>
        that
        <CustomSelect
          className='btn btn-primary dropdown-toggle fw-bold'
          tag="button"
          options={expressionOption}
          onChange={(item) => handleOperationSelectChange("subType", item.value)}
          value={expressionOption[0].name}
          disabled={!canEdit}
        />
        following
      </div>
      <form className='w-100 d-flex flex-column align-items-center gap-2 mt-3'>
        {matches.length > 0 ? matches.map((item, matchIdx) => {
          return (
            <div key={matchIdx} className='w-100 d-flex align-items-center match'>
              <DraggableSvg className='me-2' style={{ height: "16px" }} fill='#d5d5d5' />
              <Input type='text' className='form-control w-100' name='search' id='search' placeholder='Search for this...' data-id={matchIdx} value={item.search}
                onChange={(e) => changeOperationMatch(e, idx)} disabled={!canEdit}
              />
            </div>
          )
        }) : null}
        <div className='w-100 d-flex align-items-center'>
          <DraggableSvg className='me-2' style={{ height: "16px" }} fill='#d5d5d5' />
          <Input type='text' className='form-control w-100' name='search' id='search' placeholder='Search for this...' data-touched="false"
            onChange={(e) => handleOperationMatches(e, idx)} disabled={!canEdit} />
        </div>
      </form>
      <div className='w-100 form-check form-check-primary mt-3'>
        <Input
          className='form-check-input bg-light border-0'
          id={'caseSensitive' + idx}
          name={'caseSensitive' + idx}
          type='checkbox'
          checked={caseSensitive}
          onChange={handleCheck}
          disabled={!canEdit}
        />
        <Label className='fw-normal' for={'caseSensitive' + idx}>Case sensitive</Label>
      </div>
    </CustomCollapse>
  )
}

export default FilterCollapse
